<template>
  <div class="modal-popup">
    <div class="modal fade" id="createBookingNoteModal" tabindex="-1" role="dialog"  aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="title mt-2 ml-2">Not Oluştur</h3>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true" class="la la-close"></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="contact-form-action">
              <form method="post">
                <div class="row">
                  <div class="col-sm-6">
                    <div class="input-box">
                      <label class="label-text">Not </label>
                      <input class="form-control" v-model="bookingNote.note" id="paymentAmount" type="text" placeholder="">
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="modal-footer border-top-0 pt-0">
            <button type="button" class="theme-btn font-weight-bold font-size-15 color-text-2 mr-2" data-dismiss="modal">iptal</button>
            <button @click="accept" type="button" class="theme-btn font-weight-bold" :class="loading ? 'disabled' : ''">
              <i v-if="loading" class="la la-spinner la-spin"></i> Ekle</button>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import messagePopupManager from "../../util/messagePopupManager";

export default {
  name: "CreateBookingNotePopup",
  data:function (){
    return{
      loading:false,
      bookingNote: {}
    }
  },
  computed:{
    booking:{
      get(){
        return this.$store.getters.getBooking;
      }
    }
  },
  methods:{
    accept(){
      if(!this.loading) {
        this.loading=true;
        this.bookingNote.bookingId = this.booking.id;
        this.bookingNote.type = this.$store.getters.getBookingNoteType;
        this.$store.dispatch("createBookingNote", this.bookingNote).then(response => {
          Swal.fire({
            icon: 'success',
            title: 'Başarılı',
            text: '',
          })
          $("#createBookingNoteModal").modal("hide");
        }).catch(()=>{
        }).finally(() => {
          this.loading = false;
        })
      }
    }
  },
  mounted() {
    $('#createBookingNoteModal').on('shown.bs.modal', (e) => {
      this.bookingNote = {};
    })
  },
  updated() {

  }
}
</script>

<style scoped>

</style>